<template>
  <div
    class="sale-manage"
    :style="{ height: `${windowHeight}px` }"
  >
    <iframe
      id="iframeWin"
      ref="iframe"
      :src="iframeUrl"
      height="100%"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
      scrolling="no"
    />
  </div>
</template>

<script>
export default {
  name: 'SpShopAdminIframe',
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      BA_Url: '',
      isLoadTimeOut: false,
      iframeUrl: process.env.VUE_APP_SHOP_IFRAME
    }
  },
  computed: {
    isLoadIframe: function () {
      //如果有token
      return this.$route.path !== '/auth/login' && !!this.$store.getters.token
    }
  },
  mounted () {
    this.postMessage()
    this.windowHeight = document.documentElement.clientHeight - 54
  },
  created () {
    this.BA_Url = process.env.BA_Url
  },
  destroyed () {
    console.log('我即将被销毁...')
    clearInterval(this.timer)
  },
  methods: {
    postMessage: function () {
      const self = this
      const postToken = self.$store.getters.token
      let contentWindow = self.$refs.iframe.contentWindow

      this.isLoadTimeOut = true
      self.timer = setInterval(() => {
        console.log('导购端正在发送shop端数据...')
        contentWindow.postMessage(
          {
            cmd: 'getTokenInfo',
            params: {
              token: postToken
            }
          },
          '*'
        )
        window.addEventListener('message', function (event) {
          var data = event.data
          if (data.cmd == 'getToken' && data.params.success) {
            console.log('导购端已接收shop端数据...')
            clearInterval(self.timer)
          }
        })
      }, 400)
    }
  }
}
</script>

<style lang="scss" scoped>
.sale-manage {
  // width:1300px;
  // height: 2000px;
  width: 100%;
  iframe {
    width: 100% !important;
  }
}
</style>
